import React from "react";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

const AppLogo = ({ height = 48, sx = {} }) => {
  const { i18n } = useTranslation();
  const isArabic = i18n.language?.startsWith("ar");
  const logoSrc = isArabic ? "/Logo_ar.png" : "/Logo_en.png";
  const alt = isArabic ? "نظام إدارة التقارير" : "Reports Management System";

  return (
    <Box
      component="img"
      src={logoSrc}
      alt={alt}
      sx={{
        height,
        width: "auto",
        maxWidth: "100%",
        objectFit: "contain",
        display: "block",
        ...sx,
      }}
    />
  );
};

export default AppLogo;
